<template>

    <b-form-row>
      <!-- <b-col cols="12" class="my-4">
        <b-alert variant="warning" :show="tokenRequested" dismissible>Default Alert</b-alert>
      </b-col> -->
      <b-col cols='12' class="my-4 center"> 
        <h2 v-if=(user)>Hi, {{user.displayName || user.email}}</h2>
          <!-- <b-btn :hidden="status" class="my-2 my-0" size="lg" @click="signIn" variant="outline-warning">Sign In</b-btn>
          <br> -->
          <h2>Let us send you some Happiness (Happy) Token to your Ethereum Wallet</h2>
          <br>
          <b-input-group size="lg" prepend="Ethereum Wallet Address">
            <b-input :placeholder="walletComment" :readonly="!user || tokenRequested" v-model="ethAdd"></b-input>
            <b-input-group-append>
              <b-btn @click="requestHappy" :disabled="!user|| tokenRequested" variant="warning">{{happyButton}}</b-btn>
            </b-input-group-append>   
          </b-input-group> 
        <!-- <a href="https://t.me/btrworks" >
            <font-awesome-icon class="socialicon" :icon="['fa', 'grin-beam']" pulse size="10x"/> 
        </a> -->
        <!-- <h4>Network : {{address}}</h4>
        <b-form-select v-model='address' :options='options' class='mb-3'/>
        <h4>Contract : </h4>
        <b-form-select v-model='contractAdd' :options='contracts' class='mb-3'/>
        <h4>Eth Address : </h4>
        <b-form-select v-model='ethAdd' :options='ethadds' class='mb-3'/>
        <b-btn @click='getTokenInfo'>Get Token Info</b-btn>
        <b-btn @click='getContractBalance'>Get Token Balance</b-btn>
        <b-btn @click='getETHBalance'>Get ETH Balance</b-btn> -->
         
              <!-- <h3>Token: {{tokenName}} ({{tokenSymbol}})</h3>
              <h3>Token Balance: {{tokenBalance}}</h3>
              <h3>Total Supply: {{totalSupply}}</h3>

              <h3>ETH Balance: {{balance}}</h3> -->
        <div class="text-center">    
         <br>   
         By proceeding you accept the  <router-link to="happyterms" target="_blank"> Terms and Conditions </router-link> of the Happiness Tokens   
        </div>
      </b-col>   
    </b-form-row>
     <!-- <pre>{{user | pretty}}</pre>
     <pre>{{userSettings | pretty}}</pre>   -->
     <!-- <pre>{{events | pretty}}</pre>      -->
</template>

<script>
import * as firebase from 'firebase'
// import { erc20ABI } from '@/helpers/ERC20ABI'
import Icon from 'vue-awesome/components/Icon'
// import Web3 from 'web3'
export default {
  props: {
    user: {
      default: {
        displayName: 'hello'
      }
    }
  },
  name: 'hello',
  components: Icon,

  data () {
    return {
      // walletComment: 'Sign In to Add Wallet Address',
      happyButton: 'Send',
      userSettings: [],
      events: [],
      status: '',
      address: 'https://mainnet.infura.io/v3/982307e2834b4d189a08c2f4fbb9f44f',
      contractAdd: '0x2c2ac8ab03f9720ae5d3bdda57320d11ce2b082b', // ziggy main net
      ethAdd: '',
      msg: 'Welcome to Your Vue.js App',
      balance: '',
      tokenName: '',
      tokenSymbol: '',
      tokenBalance: '',
      totalSupply: '',
      tokenRequested: false
    }
  },

  computed: {
    walletComment () {
      if (this.user) {
        if (this.tokenRequested) {
          this.happyButton = 'Pending'
          return 'Pending Delivery of Happiness' // signed in and requested
        } else {
          this.happyButton = 'Send'
          return ' Add Wallet Address ' // Signed in
        }
      } else {
        this.happyButton = 'Send'
        return ' Sign in to Add Wallet Address' // Not Signed in
      }
    }
  },
  methods: {
    loadUserSettings () {
      firebase.database()
        .ref('/user/' + this.user.uid + '/settings/')
        .once('value')
        .then((data) => {
          if (data.val()) {
            this.userSettings = data.val() // push the loaded stuff to local user assets
            console.log('Got User Settings', this.userSettings)
          } else {
            this.saveUserSettings() // or if there is no data save whatever is in the local state to the database
          }
        })
        .catch((error) => {
          console.log(error)
        })
    },
    loadUserEvents () {
      firebase.database()
        .ref('/user/' + this.user.uid + '/events/')
        .once('value')
        .then((data) => {
          if (data.val()) {
            let obj = data.val()
            let records = []
            for (let key in obj) {
              records.push({
                id: key,
                description: obj[key].description,
                type: obj[key].type,
                payload: obj[key].payload,
                date: obj[key].date
              })
            }
            this.events = records// push the loaded stuff to local user assets
            console.log('Got User Events', this.events)
            this.checkEvents()
          }
        })
        .catch((error) => {
          console.log(error)
        })
    },
    loadUserPortfolio () {
      firebase.database()
      .ref('/user/' + this.user.uid + '/portfolio/')
      .once('value')
      .then((data) => {
        if (data.val()) {
          console.log('Got User Data', data.val())
          // this.trashCollect()  // clear out what ever is there
          this.user.assets = data.val() // push the loaded stuff to local user assets
          // this.setupSockets() // set up new sockets
        } else {
          // this.saveUserData() // or if there is no data save whatever is in the local state to the database
        }
      })
      .catch((error) => {
        console.log(error)
      })
    },
    requestHappy () {
      let d = new Date()
      let eventData = {
        date: d.toString(),
        type: 'request',
        description: 'Happy Token Promo 2018',
        payload: {
          ethAddress: this.ethAdd
        },
        status: 'Pending'
      }
      // this.events.push(eventData)
      console.log('Requesting via Event:', eventData)
      firebase.database()
      .ref('/user/' + this.user.uid + '/events/')
      .push(eventData)
      .then((data) => {
        console.log('Returned:', data)
      })
      .catch((error) => {
        console.log(error)
      })
      let wallet = {
        name: 'Etherium',
        type: 'Etherium',
        address: this.ethAdd
      }
      firebase.database()
      .ref('/user/' + this.user.uid + '/wallets')
      .push(wallet)
      .then((data) => {
        console.log('Added Address:', this.ethAdd)
        this.happyRequestAck(this.ethAdd)
      })
      .catch((error) => {
        console.log(error)
      })
    },
    checkEvents () {
      console.log('Checking Events')
      let record = ''
      for (let i = 0; i < this.events.length; i++) {
        record = this.events[i]
        console.log('Event:', i, record)
        // this.walletComment = 'Add Wallet Address'
        this.happyButton = 'Send'
        this.tokenRequested = false
        if (record.description === 'Happy Token Promo 2018') {
          this.tokenRequested = true
        }
      }
    },
    happyRequestAck (address) {
      console.log('Acknowledged Request to Deposit Happy to Eth:', this.ethAdd)
      this.ethAdd = ''
      this.loadUserSettings()
      this.loadUserEvents()
      this.tokenRequested = true
      // this.walletComment = 'Happiness Request'
      // this.happyButton = 'Pending'
    }
  //   getETHBalance () {
  //     console.log('Address:', this.address)
  //     console.log('Eth Address:', this.ethAdd)
  //     var query = new Web3(this.address)
  //     query.eth.getBalance(this.ethAdd, (error, wei) => {
  //       if (error) {
  //         console.log('Unknown Error')
  //         return
  //       }
  //       this.balance = Web3.utils.fromWei(wei, 'ether')
  //     })
  //   },
  //   getContractBalance () {
  //     console.log('Getting Contract Balance:', this.contractAdd)
  //     var query = new Web3(this.address)
  //     var contract = new query.eth.Contract(this.ERC20ABI, this.contractAdd)
  //     console.log('Contract', contract)
  //     contract.methods.balanceOf(this.ethAdd).call((error, result) => {
  //       if (error) {
  //         console.log('Unknown Error')
  //         return
  //       }
  //       this.tokenBalance = result
  //       console.log('Balance:', result)
  //     })
  //   },
  //   getTokenInfo () {
  //     console.log('Getting TotalSupply:', this.contractAdd)
  //     var query = new Web3(this.address)
  //     var contract = new query.eth.Contract(this.ERC20ABI, this.contractAdd)
  //     contract.methods.totalSupply().call((error, result) => {
  //       if (error) {
  //         console.log('Unknown Error')
  //         return
  //       }
  //       this.totalSupply = result
  //       console.log('Total Supply:', result)
  //     })
  //     contract.methods.name().call((error, result) => {
  //       if (error) {
  //         console.log('Unknown Error')
  //         return
  //       }
  //       this.tokenName = result
  //       console.log('TokenName:', result)
  //     })
  //     contract.methods.symbol().call((error, result) => {
  //       if (error) {
  //         console.log('Unknown Error')
  //         return
  //       }
  //       this.tokenSymbol = result
  //       console.log('TokenSymbol:', result)
  //     })
  //   }
  },
  mounted () {
    console.log('Mounted Check Events')
    this.loadUserEvents()
  },
  beforeCreate: function () {
    // firebase.auth().onAuthStateChanged((response) => {
    //   if (response) {
    //     this.user = response
    //       // LOAD EXISING ACCOUNTS HERE
    //     this.status = true
    //     console.log('Got a User')
    //     console.log('Userdata', this.user)
    //     // load user info !!!!!!!!!!!!!!!!!!!!!!
    //     // this.loadUserPortfolio()
    //     this.walletComment = 'Add Wallet Address'
    //     this.happyButton = 'Send'
    //     this.loadUserSettings()
    //     this.loadUserEvents()
    //   } else {
    //     console.log('No User')
    //     this.user = ''
    //     this.status = false
    //   }
    // })
  }
}
</script>

<!-- Add 'scoped' attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  text-align: center;
  font-weight: normal;
  color: grey;
  font-family: 'Lato', Helvetica, Arial, sans-serif;
}
ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}
a.nav-link {
  padding-top: 12px;
  color:grey;
}
.socialicon {
  margin: 10px;
  color: grey;
}

</style>



// WEBPACK FOOTER //
// src/components/splash/btr-happyoffer.vue